import React from 'react'
import AboutHero from '../Components/AboutUsPage/AboutHero'
import AboutClaritySection from '../Components/AboutUsPage/AboutClaritySection'
import MissionStatement from '../Components/LandingPage/MissionStatement'
import FinalCTA from '../Components/LandingPage/FinalCTA'

const AboutUs = () => {
  return (
    <div>
        <AboutHero />
        <AboutClaritySection />
        <MissionStatement />
        <FinalCTA />

    </div>
  )
}

export default AboutUs